export default function (url: string, returnText: string) {
  const returnUrl = window.location.href;
  const returnToText = `Return to ${returnText}`;
  return `${url}?return_text=${encodeURIComponent(
    returnToText
  )}&return_url=${encodeURIComponent(returnUrl)}`;
}
